import { render, staticRenderFns } from "./el-enroll-infoOld.vue?vue&type=template&id=ca656c9e&lang=pug"
import script from "./el-enroll-infoOld.vue?vue&type=script&lang=js"
export * from "./el-enroll-infoOld.vue?vue&type=script&lang=js"
import style0 from "./el-enroll-infoOld.vue?vue&type=style&index=0&id=ca656c9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports